import { FC, useMemo } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { CButton, ProfileEmbedded, Section } from "components";
import { useUser } from "context";
import { getToken } from "utils";
import { useTracking } from "hooks";
import { ANALYTICS_EVENTS } from "constants/analyticEvents";
import { MAIN_SITE, TEXTS } from "../../../constants";
import { PAGES } from "../../../constants/pages";
import MovedToTemplatesNotice from "../../settings/MovedToTemplatesNotice";

const EmbeddedContent: FC = () => {
  const [{ currentProfile }] = useUser();
  const track = useTracking();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const getItemLinkParams = useMemo(() => {
    return new URLSearchParams({
      token: String(getToken().accessToken),
      refreshToken: String(getToken().refreshToken),
      isBusinessProfile: "true",
      profileID: String(currentProfile?.id),
      redirectTo: PAGES.EDIT_CARD_DETAILS,
    }).toString();
  }, [currentProfile?.id]);

  return (
    <>
      <Section
        label="Content"
        subLabel="Edit your company profile page — the content shown on your /company page."
        showBorder={false}
      >
        <MovedToTemplatesNotice
          message={TEXTS.movedToTemplates.businessContent}
        />
        <CButton
          mt="16px"
          width={["100%", "49%"]}
          onClick={() => {
            onOpen();
            track({ eventName: ANALYTICS_EVENTS.COMPANY_PROFILE_EDIT_PROFILE });
          }}
        >
          Edit profile
        </CButton>
      </Section>
      <ProfileEmbedded
        isOpen={isOpen}
        onClose={onClose}
        profileId="1"
        teamId="1"
        roleId={1}
        link={`${MAIN_SITE}/o/auth/login-with-token?${getItemLinkParams}`}
      />
    </>
  );
};

export default EmbeddedContent;
